import * as React from 'react'
// libs
import { Helmet } from 'react-helmet-async'
// components
import PlansTable from './components/Table'
import RegistersFilter from 'components/UI/PageSearch/filters/RegistersFilter'
import MainLayoutContainer from 'containers/MainLayout/index'
import { CreatePlanButton } from 'components/CTAs'
// context
import { PlansPageContext } from 'containers/Plan/Register/layers/API'
// hooks
import { useCurrentUser } from 'hooks/index'
// view components
import Search from 'components/UI/PageSearch'
import NavigationSidebar from 'components/UI/NavigationSidebar'
// themes
import { LayoutContainerInnerWrapper } from 'themes/views/layouts'

const Plans: React.FC = () => {
  const { config, isLoading, pageFilter } = React.useContext(PlansPageContext)

  const {
    permissionsFromSecurityGroups: { createPlan }
  } = useCurrentUser()

  return (
    <>
      <Helmet>
        <title>Skefto - {pageFilter || 'Plans'}</title>
      </Helmet>
      <MainLayoutContainer
        isLoading={isLoading}
        CTA={
          <>
            <Search name={'name'} filter={RegistersFilter} />
            {createPlan && <CreatePlanButton />}
          </>
        }>
        <NavigationSidebar config={config} />
        <LayoutContainerInnerWrapper>
          <PlansTable />
        </LayoutContainerInnerWrapper>
      </MainLayoutContainer>
    </>
  )
}

export default Plans
